import { openSnackbar } from '../../_Components/Notifier';

export function notify(obj) {
  openSnackbar(obj);
}